function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { v4 as uuidV4 } from 'uuid';
import { clone } from 'ramda';
import cabinetActionCreators from '../actions/cabinetActionCreators';
import formModalActionCreators from '../actions/formModalActionCreators';
import store from '../reducers/storeRegistration';
const evaluateFormat = require('../../behaviors/src/lib/evaluateFormat');
const evaluateSource = require('../../behaviors/src/lib/evaluateSource');

/**
 *  Display a FormModal
 *
 *  There are two forms that are managed by presentModalBehavior: the calling form and the
 *  temporary form used withing the modal.
 */
export const evaluate = async (entity, entityName, source, content, parentContentPath, transientContext, nativeFunctions) => {
  var _source$size;
  const {
    children = [],
    // format fragment for the modal dialog
    saveActions = [],
    // behavior actions to be performed after save
    validation // behavior to validate the form
  } = source;

  // For the modal editor, a new context and content is created and behaviors, including validation,
  // will run in the modal context.
  const modalSourceEvaluator = (newSource, newContent) => evaluateSource.evaluateSource(newSource, newContent, '',
  // parentContentPath is set to the root for in-form behaviors and validation
  transientContext, nativeFunctions);

  // Run behaviors in the calling context with an overridable transient context
  const callingContextSourceEvaluator = (newSource, newTransientContext = transientContext) => evaluateSource.evaluateSource(newSource, content, parentContentPath, newTransientContext, nativeFunctions);

  // create a function to run validation behaviors in the modal context
  const validationFunction = newContent => validation ? modalSourceEvaluator(validation, newContent) : null;

  // The context and content of the calling form is used when calling saveActions, so that
  // the original form can be modified. The modal's form is passed in as transientContext.content
  const saveFunction = async newContent => {
    const newTransientContext = clone(transientContext);
    newTransientContext.content = newContent;
    for (let i = 0; i < saveActions.length; i += 1) {
      const saveAction = saveActions[i];

      // eslint-disable-next-line no-await-in-loop
      await callingContextSourceEvaluator(saveAction, newTransientContext);
    }
    const {
      cabinetIdentifier
    } = transientContext;
    if (cabinetIdentifier) {
      // refresh the cabinet
      const currentIndexQuery = store.getState().cabinet[cabinetIdentifier].indexQuery;
      currentIndexQuery.initialized = false; // force a reload

      await store.dispatch(cabinetActionCreators.serverIndex(cabinetIdentifier, currentIndexQuery));
    }
    return true;
  };

  // initial content, saveTitle, and title can all be behaviors and need evaluation
  const initialContent = (await callingContextSourceEvaluator(source.initialContent)) || {};
  const saveTitle = (await callingContextSourceEvaluator(source.saveTitle)) || 'Save';
  const title = (await callingContextSourceEvaluator(source.title)) || '';
  const formatBase = {
    type: 'subsection',
    variables: transientContext,
    children
  };
  const format = await evaluateFormat.evaluateFormat(initialContent, clone(formatBase), '', nativeFunctions);

  // this structure needs to match the form state so that actions work properly
  const active = {
    id: uuidV4(),
    // temporary id
    format,
    content: _objectSpread({}, initialContent)
  };
  const options = {
    activeCache: {
      formatInput: formatBase
    },
    active,
    saveActions,
    saveTitle,
    size: (_source$size = source.size) !== null && _source$size !== void 0 ? _source$size : 'lg',
    title,
    onValidate: validationFunction,
    onSave: saveFunction
  };
  store.dispatch(formModalActionCreators.open(options));
  return true;
};
export default {
  evaluate
};